import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataForCustomFormModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import { FormGroup } from '@angular/forms';
import { CreateGridRegistrationFormsService } from '@bo-client/activation-management/grid-registration/create-grid-registration-forms.service';
import { FeedInManagementInfoEnum } from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { CustomFormComponent } from '@bo-client/activation-management/custom-form.component';

@Component({
  selector: 'app-gr-confirm-feedin-configuration',
  templateUrl: './gr-confirm-feedin-configuration.component.html',
  styleUrls: ['./gr-confirm-feedin-configuration.component.scss']
})
export class GrConfirmFeedinConfigurationComponent
  implements CustomFormComponent<GridRegistrationModel, GridRegistrationModel>, OnInit
{
  @Input() data: DataForCustomFormModel<GridRegistrationModel>;
  @Output() onConfirm: EventEmitter<GridRegistrationModel> = new EventEmitter();

  public model: GridRegistrationModel;
  public currentForm: FormGroup;
  public feedInManagementInfoEnum = FeedInManagementInfoEnum;

  constructor(private createFormsGridRegistrationService: CreateGridRegistrationFormsService) {}

  ngOnInit(): void {
    this.model = this.data.model;
    this.currentForm = this.createFormsGridRegistrationService.createFeedinManagementConfigurationForm(
      this.data.model
    );
  }

  cancel() {
    this.onConfirm.emit(null);
  }

  confirm() {
    if (this.currentForm.valid) {
      this.model.feedInManagementSerialNumber = this.currentForm.get('feedInManagementSerialNumber').value;
      this.onConfirm.emit(this.model);
    } else {
      this.currentForm.markAllAsTouched();
    }
  }
}
